import { defineStore } from 'pinia';

export const useFormStore = defineStore('formStore', () => {
  const isDisabled = ref<boolean>(false);
  const isSubmitted = ref<boolean>(false);
  const fieldValues = ref<Record<string, string | number | boolean>>({});

  function setFieldValue(fieldAlias: string, value: string | number | boolean) {
    fieldValues.value[fieldAlias] = value;
  }

  function resetForm() {
    fieldValues.value = {};
    isSubmitted.value = false;
    isDisabled.value = false;
  }

  return {
    isSubmitted,
    isDisabled,
    fieldValues,
    setFieldValue,
    resetForm
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useFormStore, import.meta.hot));
}
